import { ILocalStorage, ILocalStorageResponse, ILocalStorageService } from '../local-storage-service';
// range in minutes
const TIME_RANGE: number = 15;

class LocalStorageService extends ILocalStorageService {
    public checkTimeRange(checkDate: Date | string | number, name: string, timeRange: number = TIME_RANGE): boolean {
        if (!checkDate) return false;
        const currentTime = Date.now();
        const diff: number = Math.abs(new Date(checkDate).getTime() - currentTime);
        const minutes: number = Math.floor((diff / 1000) / 60);
        if (minutes > timeRange) {
            this.deleteLocalStorageValue(name);
            return false;
        }
        return true;
    }
    public isLocalStorageValueExist(name: string): boolean {
        const value = this.getLocalStorageValue<ILocalStorageResponse>(name);
        return this.checkTimeRange(value?.creationDate, name);
    }

    public getLocalStorageValue<T>(name: string): T {
        const value = localStorage.getItem(name);
        return JSON.parse(value);
    }

    public setLocalStorageValue(data: ILocalStorage) {
        const { name, value, creationDate } = data;
        localStorage.setItem(name, JSON.stringify({
            value: value,
            creationDate: creationDate
        }));
    }

    public deleteLocalStorageValue(name: string) {
        localStorage.removeItem(name);
    }
}

export { LocalStorageService };